import React, { useState, useEffect } from "react";
// import Navbar from "../components/Navbar"; 
import Footer1 from "../components/Footer1";
import MobileNav from "../components/MobileNav";
import { motion, AnimatePresence } from "framer-motion";
import "./Projects.css";

// ✅ 1. NEW COMPONENT: Handles "Read More" and Line Breaks
const ReadMoreText = ({ text }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const maxLength = 250; // Number of characters to show before cutting off

  if (!text) return null;

  const shouldTruncate = text.length > maxLength;

  return (
    <div className="description-container">
      <p 
        className="description-text" 
        style={{ whiteSpace: "pre-wrap", marginBottom: "5px" }} // pre-wrap fixes the \n\n issue
      >
        {isExpanded || !shouldTruncate ? text : `${text.substring(0, maxLength)}...`}
      </p>
      
      {shouldTruncate && (
        <button 
          onClick={() => setIsExpanded(!isExpanded)}
          style={{
            background: "none",
            border: "none",
            color: "#666",
            cursor: "pointer",
            fontWeight: "600",
            padding: "0",
            fontSize: "0.9rem",
            textDecoration: "underline",
            marginBottom: "15px"
          }}
        >
          {isExpanded ? "Read Less" : "Read More"}
        </button>
      )}
    </div>
  );
};

// --- MOCK DATA UPDATED ---
const PROJECTS_DATA = [
  {
    id: 1,
    title: "Udaan Series",
    status: "COMPLETED", 
    category: "Art Exhibition",
    description: "Udaan” is not just a series of paintings, it is a journey of human ambition, struggle, growth, and success explained through colors and emotions by artist Mr. Anjaan Vivek.\n\nIn this video, Mr. Anjaan Vivek shares the deep concept and philosophy behind his “Udaan” painting series consisting of three artworks:\n\n🔴 Udaan Red\nRepresents the beginning of a journey toward a goal — a phase filled with passion, energy, struggle, dedication, and hard work. It reflects the fire within a person who dreams big and keeps moving forward despite challenges.\n\n🔵 Udaan Blue\nSymbolizes progress, clarity, and inner peace. This painting portrays a person who is moving in the right direction toward success while staying calm, focused, and free from distractions.\n\n🟡 Udaan Yellow\nRepresents achievement, stability, and higher growth. It reflects the stage where a person becomes successful and learns how to maintain that success while continuing to reach new heights in life.\n\nThrough colors, emotions, and artistic expression, the “Udaan” series inspires viewers to believe in their journey and embrace every phase of growth.",
    coverImage: "https://res.cloudinary.com/digze3wuc/image/upload/v1780143149/udaanThumbnail_2_z4wxmm.png",
    videoUrl: "https://www.youtube.com/embed/P5LygiGHyiY",
    gallery: [
      "https://res.cloudinary.com/digze3wuc/image/upload/v1780317487/udaan1_icn7ev.jpg",
      "https://res.cloudinary.com/digze3wuc/image/upload/v1780317521/udaan2_prq0ic.jpg",
      "https://res.cloudinary.com/digze3wuc/image/upload/v1780317514/udaan3_cgfu23.jpg"
    ]
  },
  {
    id: 2,
    title: "Uttejna",
    status: "ONGOING",
    category: "Art Exhibition",
    description: "Currently in progress. A vibrant exploration of human emotions, raw energy, and the constant stimulation of the modern mind portrayed through bold strokes and dynamic colors.",
    coverImage: "https://res.cloudinary.com/digze3wuc/image/upload/v1763390594/erawat_p_tq3nhz.jpg",
    videoUrl: "https://assets.mixkit.co/videos/preview/mixkit-sculptor-working-with-clay-4158-large.mp4",
    gallery: [
      "https://res.cloudinary.com/digze3wuc/image/upload/v1763389623/haribhumi_ptrjke.jpg",
      "/assets/Paintings/artist.jpg"
    ]
  },
  {
    id: 3,
    title: "Black Hole",
    status: "UPCOMING",
    category: "Art Exhibition",
    description: "An upcoming experimental masterpiece exploring the depths of space, gravity, the unknown, and how light interacts with absolute darkness.",
    coverImage: "https://res.cloudinary.com/digze3wuc/image/upload/v1763389356/photo_6309601541500898610_y_zmthqi.jpg",
    videoUrl: "", 
    gallery: []
  },
];

const Projects = () => {
  const [activeTab, setActiveTab] = useState("ALL");
  const [filteredProjects, setFilteredProjects] = useState([]);
  
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const statusPriority = { "UPCOMING": 1, "ONGOING": 2, "COMPLETED": 3 };
    let baseData = activeTab === "ALL" 
      ? [...PROJECTS_DATA] 
      : PROJECTS_DATA.filter(p => p.status === activeTab);
    const sortedData = baseData.sort((a, b) => statusPriority[a.status] - statusPriority[b.status]);
    setFilteredProjects(sortedData);
  }, [activeTab]);

  const checkIsEmbed = (url) => {
    if (!url) return false;
    return url.includes('youtube.com') || url.includes('youtu.be');
  };

  return (
    <>
      <MobileNav />

      <div className="projects-page">
        <div className="projects-hero">
          <div className="projects-hero-overlay">
            <motion.h1 initial={{ y: 30, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ duration: 1 }}>
              Our Artistic Journey
            </motion.h1>
            <motion.p initial={{ y: 30, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ duration: 1, delay: 0.2 }}>
                A curated timeline of creativity.
            </motion.p>
          </div>
        </div>

        <div className="projects-filter-container">
          {["ALL", "UPCOMING", "ONGOING", "COMPLETED"].map((tab) => (
            <button key={tab} className={`filter-btn ${activeTab === tab ? "active" : ""}`} onClick={() => setActiveTab(tab)}>
              {tab.replace("_", " ")}
            </button>
          ))}
        </div>

        <div className="projects-list-container">
            {filteredProjects.length > 0 ? (
                filteredProjects.map((project, index) => {
                    const isEmbed = checkIsEmbed(project.videoUrl);

                    return (
                        <motion.div className="project-row-wrapper" key={project.id} initial={{ opacity: 0, y: 80 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-100px" }} transition={{ duration: 0.8, ease: "easeOut" }}>
                            
                            <div className="project-left-media">
                                <div className="media-frame">
                                    {project.videoUrl ? (
                                        isEmbed ? (
                                            <iframe src={project.videoUrl} className="main-project-media" style={{ width: '100%', height: '100%', border: 'none' }} allowFullScreen title={project.title}></iframe>
                                        ) : (
                                            <video src={project.videoUrl} className="main-project-media" controls playsInline poster={project.coverImage} />
                                        )
                                    ) : (
                                        <img src={project.coverImage} alt={project.title} className="main-project-media" />
                                    )}
                                </div>
                            </div>

                            <div className="project-right-details">
                                <div className="detail-content">
                                    <div className="meta-tags">
                                        <span className="category-label">{project.category}</span>
                                        <span className="status-dot" data-status={project.status}></span>
                                        <span className="status-text">{project.status}</span>
                                    </div>
                                    
                                    <h2>{project.title}</h2>
                                    <hr className="title-divider"/>
                                    
                                    {/* ✅ 2. USING THE NEW READ MORE COMPONENT HERE */}
                                    <ReadMoreText text={project.description} />

                                    {project.gallery && project.gallery.length > 0 && (
                                        <div className="project-gallery-block">
                                            <h4>Gallery glimpses</h4>
                                            <div className="gallery-strip">
                                                {project.gallery.map((img, i) => (
                                                    <div 
                                                        key={i} 
                                                        className="gallery-thumb-frame" 
                                                        onClick={() => setSelectedImage(img)}
                                                        style={{ cursor: "pointer" }}
                                                    >
                                                        <img src={img} alt={`Work ${i}`} />
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </motion.div>
                    );
                })
            ) : (
                <div className="no-projects"><h3>No projects found in this category.</h3></div>
            )}
        </div>
      </div>

      <Footer1 />

      <AnimatePresence>
        {selectedImage && (
          <motion.div 
            className="lightbox-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setSelectedImage(null)}
          >
            <motion.div 
              className="lightbox-content"
              initial={{ scale: 0.8 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.8 }}
              onClick={(e) => e.stopPropagation()} 
            >
              <i className="fa-solid fa-xmark lightbox-close" onClick={() => setSelectedImage(null)}></i>
              <img src={selectedImage} alt="Enlarged view" className="lightbox-image" />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Projects;